import React from "react";

import "./FileIcon.css";

export default function FileIcon({ fileExtension }) {
  return <div className="FileIcon" data-type={fileExtension} />;
}
